import { Typography, LinearProgress, Chip } from "@mui/material";
import { AppLayout } from "../../../layouts/app";
import { useContext, useEffect, useState } from "react";
import { BreadcrumbContext } from "../../../contexts/breadcrumb";
import { Link } from "react-router-dom";
import { FilesService } from "../../../services/files";
import { CrudLayout } from "../../../layouts/crud";
import { NotificationManager } from "react-notifications";
import moment from "moment";
import { DataGridTrackerOta } from "../../../components/dataGridTrackerOta";
import { TrackersService } from "../../../services/trackers";
import { Button } from 'antd';
import { SendOutlined } from '@ant-design/icons';
import { TrackerRelationshipsService } from '../../../services/trackerRelationships';

const columns = [
    {
        field: 'deviceId',
        headerName: (
            <Typography
                sx={{ fontSize: "14px", color: '#353535' }}
                component="div"
                align="center"
            >
                ID Dispositivo
            </Typography>
        ),
        flex: 1,
        editable: false,
        headerAlign: "center",
        align: 'center',
    },
    {
        field: 'versionFirmware',
        headerName: (
            <Typography
                sx={{ fontSize: "14px", color: '#353535' }}
                component="div"
                align="center"
            >
                Versão
                <br />
                Atual
            </Typography>
        ),
        flex: 0.5,
        editable: false,
        headerAlign: "center",
        align: 'center',
    },
    {
        field: 'newVersionFirmware',
        headerName: (
            <Typography
                sx={{ fontSize: "14px", color: '#353535' }}
                component="div"
                align="center"
            >
                Nova
                <br />
                Versão
            </Typography>
        ),
        flex: 0.5,
        editable: false,
        headerAlign: "center",
        align: 'center',
        renderCell: (params) => {
            return (
                <Typography
                    sx={{ fontSize: "14px", color: '#353535' }}
                    component="div"
                    align="center"
                >
                    {params.row.newVersionFirmware === params.row.versionFirmware ? "" : params.row.newVersionFirmware}
                </Typography>
            );
        }
    },
    {
        field: 'lastUpdate',
        headerName: (
            <Typography
                sx={{ fontSize: "14px", color: '#353535' }}
                component="div"
                align="center"
            >
                Data da
                <br />
                Última Atualização
            </Typography>
        ),
        flex: 1.2,
        editable: false,
        headerAlign: "center",
        align: 'center',
        renderCell: (params) => {
            const date = params.row.lastUpdate === null ? "Sem Data" : moment(params.row.lastUpdate).format("DD/MM/YYYY HH:mm:ss");
            return (

                <Typography sx={{ fontSize: "14px", color: '#353535' }}>{date}</Typography>
            );
        }
    },
    {
        field: 'companyName',
        headerName: (
            <Typography
                sx={{ fontSize: "14px", color: '#353535' }}
                component="div"
                align="center"
            >
                Empresa
            </Typography>
        ),
        flex: 1.5,
        editable: false,
        headerAlign: "center",
        align: 'center',
    },
    {
        field: 'plateVehicle',
        headerName: (
            <Typography
                sx={{ fontSize: "14px", color: '#353535' }}
                component="div"
                align="center"
            >
                Veículo Associado
            </Typography>
        ),
        flex: 1.2,
        editable: false,
        headerAlign: "center",
        align: 'center',
    },
    {
        field: 'progress',
        headerName: (
            <Typography
                sx={{ fontSize: "14px", color: '#353535' }}
                component="div"
                align="center"
            >
                Status Download
            </Typography>
        ),
        flex: 2,
        editable: false,
        headerAlign: "center",
        align: 'center',
        renderCell: (params) => {
            const result = params.row.totalPage === 0 ? 0 : (params.row.pageCount / params.row.totalPage) * 100;
            return (
                (result === 100 || (result === 0 && params.row.totalPage === 0)) && params.row.status !== 15 ?
                    <></>
                    :
                    params.row.status === 15 ?
                        <div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <Chip label="Error ao Atualizar Firmware" color="error" >

                            </Chip>

                        </div>
                        :
                        <div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <Typography style={{ fontSize: '12px' }}>{result.toFixed(2)}%</Typography>
                            <LinearProgress color='primary' variant="determinate" value={result} style={{ marginBottom: '7px', width: '100%', height: '8px', borderRadius: '16px' }}></LinearProgress>
                        </div>

            );
        },
    },

];

export const TrackerOTA = () => {

    const filesService = new FilesService();
    const trackersService = new TrackersService();
    const trackerRelationShipService = new TrackerRelationshipsService();
    const [breadcrumbs, setBreadcrumbs] = useContext(BreadcrumbContext);
    const [trackersRelationShip, setTrackersRelationShip] = useState([]);
    const [loadingData, setLoadingData] = useState(false);
    const [loadingDataFiles, setLoadingDataFiles] = useState(false);
    const [files, setFiles] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [deviceIdsSelected, setDevicesIdsSelected] = useState([]);
    const [disableButton, setDisableButton] = useState(false);

    /**
     * Load that when the component is rendered
     */

    useEffect(() => {
        const breadcrumbs = [
            <Link key="1" to="/">
                Home
            </Link>,
            <Typography key="3" color="text.primary">
                Rastreadores OTA
            </Typography>
        ];
        let interval;
        getFiles();

        getTrackersData();

        interval = setInterval(() => {
            getTrackersData();
        }, 5000);
        setBreadcrumbs(breadcrumbs);

        return () => {
            clearInterval(interval);
        }

    }, []);

    const getFiles = () => {
        filesService.getFilesAdm().then(res => {
            setFiles(res.data);
            setLoadingDataFiles(true);
        }).catch(err => {
            setLoadingDataFiles(true);
        });
    }

    const getTrackersData = () => {
        setLoadingData(true);
        trackerRelationShipService.getOtaView().then(res => {
            setTrackersRelationShip(res.data)
            setLoadingData(false);
        }).catch(err => {
            setLoadingData(true);
        });
    }

    const handleSelectedRows = (id, version) => {
        const existingRow = selectedRows.find(row => row.id === id);
        if (existingRow) {
            const updatedRows = selectedRows.map(row =>
                row.id === id ? { ...row, version } : row
            );
            setSelectedRows(updatedRows);
        } else {
            setSelectedRows([...selectedRows, { id, version }]);
        }
    }

    const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

    const handleSendFirmware = async () => {
        setDisableButton(true);

        const promises = selectedRows.map((element, index) => {
            return delay(index * 7000) // Aguarda antes de iniciar cada requisição
                .then(() => trackersService.getCheckLastPacket(element.id.toString()))
                .then(() => trackersService.uploadTrackerFW({ id: element.id.toString(), version: element.version }))
                .then(() => {
                    NotificationManager.success(`Firmware enviado com sucesso! Rastreador: ${element.id.toString()}`, "", 3000);
                })
                .catch(err => {
                    if (err.status === 423) {
                        NotificationManager.warning("Limite máximo de 5 (cinco) atualizações simultâneas atingido! Favor tentar mais tarde.", "", 3000);
                    } else {
                        NotificationManager.warning("Rastreador com atualização em andamento!", "", 3000);
                    }
                });
        });

        await Promise.all(promises);
        setDisableButton(false);
        setSelectedRows([]);
        setDevicesIdsSelected([]);
        getTrackersData();
    };

    const handleSetDeviceIdsSelected = (newValue, rowId) => {
        if (newValue === null) {
            const updatedList = deviceIdsSelected.filter((id) => id !== rowId);
            setDevicesIdsSelected(updatedList);
        } else {
            const updatedList = [...deviceIdsSelected, rowId];
            setDevicesIdsSelected(updatedList);
        }
    }

    return (
        <>
            <AppLayout>
                <CrudLayout
                    title={
                        <>
                            Rastreadores
                        </>
                    }
                    children={
                        <DataGridTrackerOta
                            columns={columns}
                            data={trackersRelationShip}
                            selectedRowsData={handleSelectedRows}
                            files={files}
                            deviceIdSelected={handleSetDeviceIdsSelected}
                            idSelected={deviceIdsSelected}
                            selectedRows={selectedRows}
                            loadingData={loadingData}
                        />

                    }
                />
                <Button disabled={disableButton} onClick={handleSendFirmware} icon={<SendOutlined />} iconPosition={"end"} style={{ marginTop: "5px", background: "#008000", color: "white" }}>
                    Atualizar Firmware
                </Button>
            </AppLayout>
        </>
    );
}